import React from "react";
import PopupButton from "components/button/PopupButton";
import { CircleCheck, CircleX } from "lucide-react";

const ACTIONS = [
  { type: "Reject", label: "Reject", btnClass: "btn-reject w-full", icon: CircleX },
  { type: "Approve", label: "Approve", btnClass: "btn-approve w-full", icon: CircleCheck },
];

function ApprovalButtons({
  record,
  recordIdKey,
  employeeNameKey,
  moduleId,
  FormComponent,
  modalPrefix,
}) {
  const recordId = record[recordIdKey];
  const employeeName = record[employeeNameKey];

  return (
    <div className="flex gap-2 w-full">
      {ACTIONS.map((actionItem) => (
        <PopupButton
          key={`${actionItem.type}_${recordId}`}
          id={`${modalPrefix}_${actionItem.type.toLowerCase()}_${recordId}`}
          title={`${actionItem.type} Request`}
          description={`${actionItem.type} request for ${employeeName}`}
          label={actionItem.label}
          btnClass={actionItem.btnClass}
          action="edit"
          moduleId={moduleId}
          icon={actionItem.icon}
          useCustomClass
          modalWidth={512}
        >
          <FormComponent
            recordData={record}
            recordId={recordId}
            mode="edit"
            action={actionItem.type}
          />
        </PopupButton>
      ))}
    </div>
  );
}

export default ApprovalButtons;
